module.exports = __webpack_public_path__ + "img/box-arrow-down-right.c02c4de3.svg";